import MumbaiIcon from "../../assets/mumbai-icon.svg";
import { Link, styled, SxProps, Tooltip } from "@mui/material";
import CopyToClipboard from "./CopyToClipboard";

import { Link as RLink } from "react-router-dom";
import { AppRoutes } from "../../config";

type AddressLinkProps = {
  address: string;
  small?: boolean;
  type: "user" | "trust" | "token" | "admin" | "plain";
  name?: string;
  links?: boolean;
  copy?: boolean;
  long?: boolean;
  sx?: SxProps;
};

export const AddressLink = ({
  sx,
  address,
  type,
  name,
  copy = false,
  links = false,
  long = false,
}: AddressLinkProps) => {
  const _cutAddress = address?.substring(0, 6)?.toUpperCase() + "…" + address?.substr(-4)?.toUpperCase();
  const cutAddress = _cutAddress.replace("X", "x");
  const url =
    type === "trust"
      ? AppRoutes.UserWallet.path.replace(":address", address?.toLowerCase())
      : type === "user"
      ? AppRoutes.UserWallet.path.replace(":address", address?.toLowerCase())
      : type === "admin"
      ? "#"
      : type === "plain"
      ? "#"
      : AppRoutes.EcoBank.path + `?address=${address}`;

  return (
    <Row sx={sx}>
      <RLink className={`${type}Address ${!address || address === "none" ? "disabled" : ""}`} to={url}>
        {name ? (
          <Tooltip title={address}>
            <span>{name}</span>
          </Tooltip>
        ) : long ? (
          address
        ) : !address || address === "none" ? (
          ""
        ) : (
          cutAddress
        )}
      </RLink>
      {links && (
        <Link className={"iconWrap"} href={`https://mumbai.polygonscan.com/address/${address}`} target="_blank">
          <img src={MumbaiIcon} alt="Mumbai" />
        </Link>
      )}
      {copy && <CopyToClipboard text={address} />}
    </Row>
  );
};

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    font-family: IBM Mono, monospace;
    font-weight: 500;
    user-select: none;
    text-decoration: none;
    cursor: pointer;

    &.userAddress {
      color: ${({ theme }) => theme.palette.primary.main};
      text-decoration: underline;

      &:hover {
        color: ${({ theme }) => theme.palette.text.disabled};
        text-decoration: underline;
      }
    }

    &.adminAddress {
      pointer-events: none;
      color: ${({ theme }) => theme.palette.primary.main};
      text-decoration: underline;
    }

    &.trustAddress {
      color: ${({ theme }) => theme.palette.primary.main};
      text-decoration: underline;

      &:hover {
        color: ${({ theme }) => theme.palette.text.disabled};
        text-decoration: underline;
      }
    }

    &.disabled {
      pointer-events: none;
    }
    &.tokenAddress {
      color: white;
    }
    &.plainAddress {
      color: currentColor;
      pointer-events: none;
      user-select: text;
      @media (max-width: 560px) {
        font-size: 12px;
      }
    }
  }

  a.iconWrap {
    width: 28px;
    height: 28px;
    padding: 4px;
    background: white;
    border-radius: 50%;
  }

  img {
    width: 20px;
  }
`;
